var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.838 2c1.195 0 2.165.97 2.165 2.166l.003 1.334h4.245a.75.75 0 010 1.5H18.91l-.852 14.06a1 1 0 01-.998.94H6.943a1 1 0 01-1-.94L5.093 7H3.75a.75.75 0 010-1.5h4.255l-.003-1.334C8.003 2.97 8.973 2 10.169 2h3.669zm3.569 5H6.595l.818 13.5h9.176L17.407 7zM9.725 9a.75.75 0 01.776.724l.297 8.5a.752.752 0 01-.623.765l-.101.01a.75.75 0 01-.776-.724l-.296-8.499A.75.75 0 019.725 9zm4.552 0a.75.75 0 01.723.776l-.296 8.5a.75.75 0 01-.776.723l-.101-.01a.751.751 0 01-.623-.766l.297-8.499A.75.75 0 0114.277 9zm-.44-5.5H10.17a.667.667 0 00-.666.666V5.5h5V4.166a.667.667 0 00-.665-.666z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconTrash.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };